import React from "react";
import { Box } from "@mui/material";

const NavigationRailSegment = ({ children, sx = {}, ...props }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', ...sx }} {...props}>
    {children}
  </Box>
);

export default NavigationRailSegment;
